import type { ChallengeFormData } from '@schemas/challenge.schema';
import { formOptions } from '@tanstack/react-form';

export const challengeFormOptions = formOptions({
  defaultValues: {
    challengePhases: [],
    description: '',
    name: '',
  } as ChallengeFormData,
});
